import { Modal, ModalBody } from "reactstrap";
import StepOptions from "../ContactModal/StepOptions";

type DesktopContactDirectModalProps = {
  open: boolean;
  onToggle: () => void;
  onOpenChat: (channel: number) => void;
  selectedPerson: any;
}

const DesktopContactDirectModal = ({ open, onToggle, onOpenChat, selectedPerson }: DesktopContactDirectModalProps) => {

  return (
    <Modal
      className="contact-modal"
      isOpen={open}
      toggle={onToggle}
      centered
    >
      <ModalBody>
        <button type="button" className="btn-close" aria-label="Close" onClick={onToggle} />
        <StepOptions selectedPerson={selectedPerson} onOpenChat={onOpenChat} personRoleLabel={'Contact the '} />
      </ModalBody>
    </Modal>
  );
}

export default DesktopContactDirectModal;